import React from "react";
import CostRow from "./exp-cost-row";
import { calculateCostAccommodation, exchangeRate, getAccommodationBreakdown } from "./cost-helper";

const AccommodationRow = ({guideData, expData}) => {
    // Check if this is a REBEL villa (flat fee) or traditional accommodation (per attendee)
    const isVilla = expData.villaRentalFee !== undefined && expData.villaRentalFee.value !== undefined;
    const attendees = parseFloat(guideData.attendees?.value) || 1;

    // For REBEL villas: calculateCostAccommodation returns FLAT TOTAL (not per attendee)
    // For traditional: calculateCostAccommodation returns per-attendee cost
    const accommodationCost = calculateCostAccommodation(guideData, expData);

    // Get date-based breakdown if available
    const breakdown = isVilla ? getAccommodationBreakdown(guideData, expData) : null;

    // Calculate per-attendee and total costs based on type
    const perAttendeeCost = isVilla ? accommodationCost / attendees : accommodationCost;
    const totalAccommodationCost = isVilla ? accommodationCost : accommodationCost * attendees;

    const nightCount = breakdown ? breakdown.nightCount : guideData.tripLength.value;
    const avgPerNight = nightCount > 0 ? totalAccommodationCost / nightCount : 0;

    return (
        <React.Fragment>
            <CostRow title="Accommodation"
                    icon='bed'
                    single
                    currency={guideData.currency.value.slice(3)}
                    costPer={(expData, avgPerNight)}
                    perLabel={breakdown ? "avg/night" : "per night"}
                    num={nightCount}
                    type="nights"
                    subtotal={perAttendeeCost}
                    attendees={attendees}
                    accommodation={expData}
                    exchangeRate={exchangeRate}
                    villaSubtotal={isVilla ? totalAccommodationCost : undefined}
                    breakdown={breakdown}
            />
        </React.Fragment>
    )
}

export default AccommodationRow;